<template lang="html">
  <modal
    id="fullscreen"
    name="fullscreen"
    class="fullscreen img-group"
    ref="fullscreen"
    v-if="showModal"
    v-model="showModal"
    size="lg"
    :transition-duration="0"
    :header="false"
    :footer="false"
    @click.native="closeMe()"
    @close="showModal = false">

    <div class="img-group">
      <carousel
        v-if="images"
        :indicators="(images.length > 100 ? true : false)"
        :controls="(images.length > 1 ? true : false)"
        :interval=0
        v-model="index">
          <slide
            v-for="(image, index) in images"
            :key="index">
            <div class="img-group__container">
              <img
                class="img-group__img"
                :src="$imageResize(image.imgc.url, image.imgc.width)"
                :alt="image.imgc.caption"
                :title="image.imgc.description">
            </div>
            <div
              v-if="image.imgc.caption"
              class="img-group__info"
              :style="{width:image.imgc.width+'px'}">
              <p class="text-stroke text-stroke--fullscreen">
                {{ stripTags(image.imgc.caption) }}
              </p>
            </div>
          </slide>
      </carousel>
    </div>

    <div class="modal-gallery">
      <a @click.prevent="hideMe(index)">
        <img
          class="modal-gallery__close"
          :src="$getImagePath('images', 'icon_close.svg')">
      </a>
    </div>

  </modal>
</template>

<script>
import api from '@/api'
import EventBus from '@/eventbus'

export default {
  name: 'Fullscreen',
  data() {
    return {
      showModal: false,
      images: null,
      index: 0
    }
  },
  created() {
    EventBus.$on('transmitter-in', this.showMe)
  },
  beforeDestroy() {
    EventBus.$off('transmitter-in')
  },
  methods: {
    showMe(data) {
      // console.log('showMe: ', data)
      this.showModal = true
      this.images = data.images
      this.index = data.index
    },
    hideMe(index) {
      // console.log('hideMe: ', index);
      document.querySelector('body').classList.remove('modal-open')
      this.showModal = false
      // send the index back to the parent
      EventBus.$emit('transmitter-out', index)
    },
    closeMe() {
      let index = this.index
      let elm = event
      let className = elm.target.className

      // close modal on click outside of image / arrows
      if(className.search('modal-body') > -1) {
        this.hideMe(index)
      }
    },
    stripTags(string) {
      return string.replace(/<[^>]+>/g, '')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/Fullscreen.vue